import { useFetch } from "react-admin-base";
import { Link, useParams } from "react-router-dom";
import { Row, Col, Card, CardBody } from "reactstrap";
import { UserCover } from "../../Components/Avatar";
import Countries from '../../data/countries.json';
import Languages from '../../data/languages.json';
import { List } from "../Mentor/Mentor";
import Levels from '../../data/levels.json';
import Topics from "../../data/topics.json";
import Sports from "../../data/sports.json";
import { useUser } from "../../Components/UserProvider";
import { FormattedMessage } from "react-intl";

const TopicsAndSports = Topics.concat(Sports);

const types = {
	'1': 'Profit',
	'2': 'Non-Profit',
	'3': 'Social Enterprise'
};

export function MenteePage({id}) {
	const user = useUser();
	const [ mentee ] = useFetch('/mentee/' + id);
	
	if (!mentee)
		return null;
	
	return <>
		<UserCover user={mentee.user} />
		<Row>
			<Col md="6">
				<Card>
					<CardBody className="d-flex flex-column">
						<h2>{ mentee.user.name }</h2>
						
						<div className="mb-2">
							<p className="mb-0">
								<i className="fas fa-envelope" /> <a href={"mailto:" + mentee.user.email}>{mentee.user.email}</a>
							</p>
							
							{ mentee.linkedin_profile && <p className="mb-0">
								<i className="fab fa-linkedin" /> <a href={mentee.linkedin_profile} target="_blank" rel="noopener">{mentee.linkedin_profile}</a>
							</p> }
							
							{ mentee.venture_website && <p className="mb-0">
								<a href={mentee.venture_website} target="_blank" rel="noopener">{mentee.venture_website}</a>
							</p> }
							
							{ mentee.location_id && <p className="mb-0">
								<i className="fas fa-compass" /> {Countries[mentee.location_id]}
							</p> }
							
							{ mentee.language_ids && <p className="mb-0">
								<i className="fas fa-globe" /> { mentee.language_ids.map(a => Languages[a].name).join(', ') }
							</p> }
						</div>
						
						<h2>{mentee.venture_name}</h2>
						<h3>{types[mentee.type]}</h3>
						
						<p>
							{ mentee.about }
						</p>
						
						<Row>
							{ id != user.id && <Col>
								<Link to={"/chat/" + mentee.user.id} className="btn btn-primary d-block">
									<i className="fas fa-comments" /> <FormattedMessage id="SEND_MESSAGE" />
								</Link>
							</Col> }
							{ (id == user.id || user.type === 512) && <Col>
								<Link to={id == user.id ? "/profile" : "/mentee/" + mentee.user.id + "/edit"} className="btn btn-primary d-block">
									<i className="fas fa-pencil-alt" /> <FormattedMessage id="EDIT_PROFILE" />
								</Link>
							</Col> }
						</Row>
					</CardBody>
				</Card>
			</Col>
			<Col md="6">
				<Card>
					<CardBody className="d-flex flex-column">
						<List
							icon="chart-area"
							data={Levels}
							title="FOCUS_AREA"
							value={[mentee.focus_area_id]}
						/>
						
						<List
							icon="vial"
							data={TopicsAndSports}
							title="FIELDS_OF_ACTIVITY"
							value={(mentee.assessment_ids || []).filter(a => Sports.find(b => b.id == a))}
						/>
						
						<List
							icon="snowboarding"
							data={TopicsAndSports}
							title="FIELDS_OF_NEEDS"
							value={(mentee.assessment_ids || []).filter(a => Topics.find(b => b.id == a))}
						/>
					</CardBody>
				</Card>
			</Col>
		</Row>
	</>;
}

export default function Mentee() {
	const { id } = useParams();
	return <MenteePage
		id={id}
	/>
}

